import { Link } from "react-router-dom";
import { HeartHandshake, Phone, MapPin, Mail, Instagram, Facebook } from "lucide-react";
import { MAP_EMBED_URL } from "@/lib/mapConfig";

export const Footer = () => (
  <footer className="bg-primary text-primary-foreground border-t border-border">
    <div className="max-w-7xl mx-auto px-5 md:px-10 py-16 grid grid-cols-1 md:grid-cols-4 gap-12">
      <div className="md:col-span-2">
        <Link to="/" className="flex items-center gap-2 mb-4">
          <HeartHandshake className="h-6 w-6 text-accent" strokeWidth={1.5} />
          <span className="font-heading text-2xl font-semibold">PhysioAbhi Healthcare Foundation</span>
        </Link>
        <p className="text-primary-foreground/70 max-w-md leading-relaxed">
          A Section 8 nonprofit delivering free and subsidised physiotherapy to elderly people,
          children with special needs, and underserved athletes across Bengaluru.
        </p>
        <div className="flex gap-4 mt-6">
          <a href="#" data-testid="footer-social-instagram" aria-label="Instagram" className="p-2 border border-primary-foreground/20 hover:border-accent hover:text-accent transition-colors">
            <Instagram className="h-4 w-4" />
          </a>
          <a href="#" data-testid="footer-social-facebook" aria-label="Facebook" className="p-2 border border-primary-foreground/20 hover:border-accent hover:text-accent transition-colors">
            <Facebook className="h-4 w-4" />
          </a>
        </div>
      </div>

      <div>
        <h4 className="font-heading text-lg mb-4">Quick Links</h4>
        <ul className="space-y-2 text-primary-foreground/70">
          <li><Link to="/about" className="hover:text-accent transition-colors">About Us</Link></li>
          <li><Link to="/programs" className="hover:text-accent transition-colors">Programs</Link></li>
          <li><Link to="/gallery" className="hover:text-accent transition-colors">Gallery</Link></li>
          <li><Link to="/events" className="hover:text-accent transition-colors">Events</Link></li>
          <li><Link to="/blog" className="hover:text-accent transition-colors">Blog</Link></li>
          <li><Link to="/donate" className="hover:text-accent transition-colors">Donate</Link></li>
        </ul>
      </div>

      <div>
        <h4 className="font-heading text-lg mb-4">Reach Us</h4>
        <ul className="space-y-3 text-primary-foreground/70 text-sm mb-4">
          <li className="flex gap-2"><MapPin className="h-4 w-4 shrink-0 mt-0.5 text-accent" />Ground Floor, Kamala Ark, Judicial Layout, Thalaghattapura, Kanakapura Road, Bengaluru 560109</li>
          <li className="flex gap-2"><Phone className="h-4 w-4 shrink-0 text-accent" /><a href="tel:7990793367" data-testid="footer-phone-1" className="hover:text-accent">7990793367</a> / <a href="tel:7507939338" data-testid="footer-phone-2" className="hover:text-accent">7507939338</a></li>
          <li className="flex gap-2"><Mail className="h-4 w-4 shrink-0 text-accent" /><a href="mailto:care@physioabhi.org" className="hover:text-accent">care@physioabhi.org</a></li>
        </ul>
        <div data-testid="footer-map" className="border border-primary-foreground/20 aspect-[4/3] overflow-hidden">
          <iframe
            title="PhysioAbhi Location"
            src={MAP_EMBED_URL}
            className="w-full h-full"
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          />
        </div>
      </div>
    </div>
    <div className="border-t border-primary-foreground/10 py-6 text-center text-xs text-primary-foreground/50">
      © {new Date().getFullYear()} PhysioAbhi Healthcare Foundation. A Section 8 Nonprofit. All rights reserved.
    </div>
  </footer>
);
